<template>
  <v-container>
    <v-tab-item class="pb-0" eager>
      <first-tab
        @stepReleased="$emit('step-observer', {step: 0, complete: $event})"
      />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <second-tab
        @stepReleased="$emit('step-observer', {step: 1, complete: $event})"
      />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <third-tab
        @stepReleased="$emit('step-observer', {step: 2, complete: $event})"
      />
    </v-tab-item>
  </v-container>
</template>

<script>
export default {
  components: {
    FirstTab:  () => import("@/components/simulacoesLaudosIncrementais/tabs/FirstTab.vue"),
    SecondTab: () => import("@/components/simulacoesLaudosIncrementais/tabs/SecondTab.vue"),
    ThirdTab:  () => import("@/components/simulacoesLaudosIncrementais/tabs/ThirdTab.vue")
  },

  methods: {
    exportData() {
      const vuexData = this.$store.state.simulacaoLaudoIncremental;

      let calculos = [];
      (Object.entries(vuexData.saneamentoVoc.calculos)).forEach(calculo => {
        calculo = calculo[1];
        if (calculo.saneamento_voc_id) {
          calculos.push({
            simulacao_laudo_incremental_id: this.$route.params.id ? this.$route.params.id : null,
            saneamento_voc_id: calculo.saneamento_voc_id,
            saneamento_voc_nome: calculo.nome_calculo,
            tipologia_aneel: calculo.tipologia_aneel
          });
        }
      });

      return {
        id: this.$route.params.id ? this.$route.params.id : null,
        titulo: vuexData.titulo,
        possui_obra: vuexData.possuiObra,
        possui_material: vuexData.possuiMaterial,
        deprecia_mes: vuexData.depreciaMes,
        vlr_almoxarifado_em_operacao: vuexData.vlrAlmoxarifado,
        data_base: vuexData.aisDataBase,
        origem_dados_ais: vuexData.origemDadosAis,
        data_imobilizacao_inicio: vuexData.dataImobilizacaoInicio,
        data_imobilizacao_fim: vuexData.dataImobilizacaoFim,
        origem_dados_banco_precos: vuexData.origemDadosBancoPrecos,
        banco_preco_calculo_id: vuexData.bancoPrecos.id,
        banco_precos_materiais: vuexData.bancoPrecosMateriais,
        banco_precos_materiais_arquivo_id: vuexData.infoUploadedFileMaterial.id,
        banco_precos_materiais_delimitador: vuexData.infoUploadedFileMaterial.delimitador,
        banco_precos_materiais_involucro: vuexData.infoUploadedFileMaterial.involucro,
        banco_precos_materiais_escape: vuexData.infoUploadedFileMaterial.escape,
        banco_precos_materiais_mapeamento_arquivo: vuexData.bancoPrecosMateriais ? JSON.stringify(vuexData.infoUploadedFileMaterial.mapeamento) : null,
        banco_precos_tucagens: vuexData.bancoPrecosTucagens,
        banco_precos_tucagens_arquivo_id: vuexData.infoUploadedFileTucagem.id,
        banco_precos_tucagens_delimitador: vuexData.infoUploadedFileTucagem.delimitador,
        banco_precos_tucagens_involucro: vuexData.infoUploadedFileTucagem.involucro,
        banco_precos_tucagens_escape: vuexData.infoUploadedFileTucagem.escape,
        banco_precos_tucagens_mapeamento_arquivo: vuexData.bancoPrecosTucagens ? JSON.stringify(vuexData.infoUploadedFileTucagem.mapeamento) : null,
        percentuais: JSON.stringify(vuexData.percentuais),
        calculos_saneamentos_voc: calculos,
        data_simulacao_laudo: vuexData.dataSimulacaoLaudo
      };
    }
  }
}
</script>